import React, { useState, useEffect } from "react";
var configs = require("../../../../../public/config");

import Api from "../../../../lib/componentApi";
import { percentage } from "../../../../lib/math";

import Loading from "../../../../components/Common/Loading";
import AppCenteredInfo from "../../../../components/Common/AppCenteredInfo";

const Points = ({ userGroup, firstName, lastName, points, referralCode }) => {
  const [rewardsData, setRewardsData] = useState(null);
  const [isShowingInfo, setToggleInfo] = useState(false);
  const [popupData, setPopupData] = useState({});

  const handleCopy = () => {
    const copyTex =
      (referralCode && `https://mylocale.co.uk/invite/${referralCode}`) ||
      configs.shareTheLoveUrl;
    try {
      const node = document.createElement("textarea");
      node.innerHTML = copyTex;
      document.body.appendChild(node);
      node.select();
      document.execCommand("copy");
      node.style.display = "none";
    } catch (error) {
      console.log(error);
    }
  };

  const getMatchedPopupData = (targetId, dynamicParam) => {
    let title, body, buttonText, buttonIcon;
    switch (parseInt(targetId)) {
      case 1:
        title = "Rewarding Takeaways";
        body = `Earn ${dynamicParam}% back in eCoins with every food order. \n Supporting local pays.`;
        buttonText = "Tasty!";
        buttonIcon = null;
        break;
      case 2:
        title = "Earn and Burn";
        body = `Walk off the calories and get an extra ${dynamicParam}% back when you click and collect.`;
        buttonText = "Get me my shoes!";
        buttonIcon = null;
        break;
      case 3:
        title = "Tell Me More, Tell Me More…";
        body = `Was it love at first bite? Leave a review in the orders section and get an extra ${dynamicParam} eCoins.`;
        buttonText = "Sounds great!";
        buttonIcon = null;
        break;
      case 4:
        title = "As Easy As 1, 2, 3…";
        body = `<strong>1.</strong>${(referralCode &&
          "Copy your referral code") ||
          "Register and copy your referral code"} \n <strong>2.</strong> Share it with friends and family \n <strong>3.</strong> Earn ${dynamicParam} eCoins when they order with it \n\n <strong>Referral Code</strong> \n\n <strong>${referralCode}</strong>`;
        buttonText = "Share the love!";
        buttonIcon = "icon-shape";
        break;
      case 5:
        title = "Level Up!";
        body = `Order ${dynamicParam} times in a month and you'll become a Local E Ninja for the next month, earning 50% more rewards on a regular order.`;
        buttonText = "Challenge Accepted";
        buttonIcon = null;
        break;
      case 6:
        title = "Points of Interest";
        body = `Stack up your eCoins earned from orders and reviews at the Local E piggy bank to earn even more rewards and free food.`;
        buttonText = "Oink oink!";
        buttonIcon = null;
        break;
      case 7:
        title = "A Rewarding Journey";
        body = `Get a ${dynamicParam} eCoin (£${parseFloat(dynamicParam *
          configs.ptsToGbp).toFixed(2)}) discount on your second order. \n \n This offer cannot be combined with a promotional offer.`;
        buttonText = "Ready, steady, go!";
        buttonIcon = null;
        break;
      default:
        title = null;
        body = null;
        buttonText = null;
        buttonIcon = null;
        break;
    }
    return { title, body, buttonText, buttonIcon };
  };

  const handleCloseInfo = isHeader => {
    const { buttonText } = popupData;
    document.body.classList.remove("body-overflow");
    if (buttonText === "Share the love!") {
      if (isHeader) {
        setToggleInfo(false);
      } else {
        handleCopy();
        const rewardsButton = document.getElementById("rewards-button");
        if (rewardsButton) {
          rewardsButton.textContent = "Share the love! (Copied!)";
          setTimeout(function() {
            rewardsButton.textContent = "Share the love!";
          }, 1000);
        }
      }
    } else {
      setToggleInfo(false);
    }
  };

  const handlePopup = (targetId, dynamicParam) => {
    document.body.classList.add("body-overflow");
    const { title, body, buttonText, buttonIcon } = getMatchedPopupData(
      targetId,
      dynamicParam
    );
    if ((title, body, buttonText)) {
      setPopupData({ title, body, buttonText, buttonIcon });
      setToggleInfo(true);
    }
  };
  useEffect(() => {
    if (!rewardsData) {
      Api.get("/api/user/rewards", {}, (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "rewards-code");
        } else {
          const { rewards } = response;
          setRewardsData(rewards);

          const badge = document.querySelector(".badge p");
          if (badge) {
            const total = getTotal(rewards);
            if (total) {
              document.querySelector(".badge p").style.left =
                `calc(${percentage(
                  100,
                  parseInt(rewards.userLocaleGoalCurrentPoints),
                  parseInt(total)
                )}% - ` +
                badge.offsetWidth / 2 +
                "px)";
            }
          }
        }
      });
    }
  }, [rewardsData]);
  const renderNinjaStars = (current, goal) => {
    const goalArray = Array.from(
      Array(parseInt(goal)),
      (x, index) => index + 1
    );
    return goalArray.map(
      goalIndex =>
        (current >= goalIndex && (
          <img key={goalIndex} src="/svg/ninja-star.svg" />
        )) || <img key={goalIndex} src="/svg/ninja-star-gray.svg" />
    );
  };
  const getBodyWithClass = className => {
    return (
      <div
        className={`white-bg mt-10px rewards-page__points__list ${className}`}
      >
        <ul>
          <li
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => handlePopup(1, rewardsData.orderRewardPercent)}
          >
            <div className="d-flex align-items-center">
              <span>{rewardsData.orderRewardPercent}%</span>
              <div className="desc">
                <h4>Order</h4>
                <p>Earn with every order.</p>
              </div>
            </div>
            <img src="/svg/rewards-arrow.svg" />
          </li>
          <li
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() =>
              handlePopup(
                2,
                rewardsData.orderCollectionCompletedRewardPercentReal
              )
            }
          >
            <div className="d-flex align-items-center">
              <span>{rewardsData.orderCollectionCompletedRewardPercent}%</span>
              <div className="desc">
                <h4>Collection</h4>
                <p>Bonus eCoins when you collect.</p>
              </div>
            </div>
            <img src="/svg/rewards-arrow.svg" />
          </li>
          {(!rewardsData.hasCompletedOrder && (
            <li
              className="d-flex justify-content-between align-items-center cursor-pointer"
              onClick={() => handlePopup(7, rewardsData.firstOrderPoints)}
            >
              <div className="d-flex align-items-center">
                <span>{rewardsData.firstOrderPoints} eCoins</span>
                <div className="desc">
                  <h4>First Order</h4>
                  <p>Order for the first time on Local E.</p>
                </div>
              </div>
              <img src="/svg/rewards-arrow.svg" />
            </li>
          )) || <noscript />}

          <li
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => handlePopup(3, rewardsData.orderReviewRewardPoints)}
          >
            <div className="d-flex align-items-center">
              <span>{rewardsData.orderReviewRewardPoints} eCoins</span>
              <div className="desc">
                <h4>Restaurant Review</h4>
                <p>Spread the word!</p>
              </div>
            </div>
            <img src="/svg/rewards-arrow.svg" />
          </li>
          <li
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => handlePopup(4, rewardsData.refGainPoints)}
          >
            <div className="d-flex align-items-center">
              <span>{rewardsData.refGainPoints} eCoins</span>
              <div className="desc">
                <h4>Referral</h4>
                <p>It pays to share the love... Literally.</p>
              </div>
            </div>
            <img src="/svg/rewards-arrow.svg" />
          </li>

          <li
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => handlePopup(5, rewardsData.localeNinjaGoal)}
          >
            <div className="d-flex align-items-center">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="33"
                  viewBox="0 0 320 305"
                >
                  <g fill="none" fillRule="nonzero">
                    <path
                      fill="#273444"
                      d="M312.885 90.798c-11.796-16.873-35.032-20.989-51.9-9.196l-15.851 11.079v-5.464c0-48.082-38.98-87.06-87.061-87.06-48.085 0-87.062 38.978-87.062 87.06v2.93l-12.226-8.545c-16.87-11.793-40.106-7.677-51.9 9.196-11.792 16.872-7.672 40.109 9.196 51.9L53.34 168.74a37.052 37.052 0 0 0 17.672 6.525v68.105c0 .307.019.575.022.875v18.127c0 23.193 18.803 41.995 41.997 41.995 23.191 0 41.993-18.802 41.993-41.995v-5.057c1.015-.028 2.028-.064 3.05-.064.833 0 1.656.033 2.484.054v5.067c0 23.193 18.802 41.995 41.995 41.995 23.194 0 41.996-18.802 41.996-41.995V252.28c.375-2.605.586-5.535.586-8.911v-67.927a37.071 37.071 0 0 0 21.297-6.703l37.257-26.042c16.869-11.791 20.989-35.028 9.197-51.9z"
                    />
                    <g transform="translate(91.086 14.981)">
                      <path
                        fill="#FCDCAB"
                        d="M137.686 61.631c0 19.545-15.843 35.389-35.39 35.389H35.44C15.893 97.02.049 81.176.049 61.63c0-19.543 15.844-35.387 35.39-35.387h66.858c19.545 0 35.389 15.843 35.389 35.387z"
                      />
                      <path
                        fill="#1D2937"
                        d="M30.636 10.187c-3.426 3.095-7.59 4.069-9.3 2.173-1.712-1.896-.323-5.939 3.104-9.034 3.425-3.092 7.588-4.064 9.3-2.168 1.711 1.894.321 5.937-3.104 9.03z"
                      />
                      <ellipse
                        cx="11.442"
                        cy="18.509"
                        fill="#1D2937"
                        rx="2.717"
                        ry="4.913"
                        transform="rotate(47.902 11.442 18.509)"
                      />
                      <path
                        fill="#1D2937"
                        d="M122.114 271.006c3.18-3.348 7.256-4.631 9.108-2.877 1.85 1.762.775 5.9-2.41 9.244-3.176 3.348-7.26 4.634-9.104 2.87-1.853-1.759-.77-5.89 2.406-9.237zM138.658 259.371c1.872-1.965 4.266-2.723 5.353-1.69 1.09 1.037.457 3.474-1.411 5.435-1.873 1.969-4.267 2.723-5.357 1.69-1.09-1.036-.454-3.47 1.415-5.435zM31.937 272.253c2.751-2.898 6.281-4.01 7.883-2.49 1.602 1.525.671 5.106-2.083 8-2.75 2.898-6.286 4.013-7.881 2.484-1.605-1.523-.669-5.096 2.081-7.994zM46.255 262.184c1.62-1.701 3.693-2.355 4.632-1.461.943.897.397 3.005-1.222 4.702-1.62 1.705-3.69 2.355-4.634 1.462-.944-.898-.393-3.003 1.224-4.703z"
                      />
                      <path
                        fill="#273444"
                        d="M24.633 70.966v-1.624c0-7.3 6.014-12.653 13.314-12.653 7.298 0 13.12 5.353 13.12 12.653v1.624h6.3c.256-1.147.408-2.334.408-3.56 0-9.15-7.304-17.063-16.454-17.063l-6.575.115c-9.151 0-16.616 7.798-16.616 16.949 0 1.225.15 2.414.408 3.559h6.095zM87.446 70.966v-1.624c0-7.3 6.014-12.653 13.314-12.653 7.301 0 13.118 5.353 13.118 12.653v1.624h6.303c.258-1.147.407-2.334.407-3.56 0-9.15-7.303-17.063-16.454-17.063l-6.575.115c-9.15 0-16.615 7.798-16.615 16.949 0 1.225.15 2.414.407 3.559h6.095z"
                      />
                    </g>
                  </g>
                </svg>
              </span>
              <div className="desc">
                <h4 className="d-flex align-items-center pt-10px">
                  <span>Local E Ninja</span>
                  {renderNinjaStars(
                    rewardsData.userLocaleNinjaCurrent,
                    rewardsData.localeNinjaGoal
                  )}
                </h4>

                <p style={{ width: "95%" }}>
                  Order {rewardsData.localeNinjaGoal} times a month to earn even
                  more kick-ass rewards.
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  };
  const getTotal = rewardsData => {
    return (
      (!rewardsData.hasCompletedOrder && rewardsData.firstOrderPoints) ||
      rewardsData.localeGoalPoints
    );
  };

  const { title, body, buttonText, buttonIcon } = popupData;

  return (
    (rewardsData && (
      <div className="rewards-page__points">
        <div className="rewards-page__points__body">
          <div className=" rewards-page__head__content">
            <strong className="hide-xs rewards-head-title">eCoin Rewards</strong>
            <p className="rewards-head-description">
              Every time you order on Local E you help keep a vibrant
              independent high street open for business, and that should be
              rewarded. Earn eCoins and spend them like cash anywhere on Local E.
            </p>
          </div>
          <div className="d-flex justify-content-around rewards-page__points__content">
            <div className="img">
              <img src="/svg/points-card.svg" />
              <div className="rewards-page__points__card">
                <div className="head d-flex justify-content-between">
                  <p>
                    <b>{points}</b> eCoins
                    <p className="points-description">
                      £1.00 = {1 / configs.ptsToGbp} eCoins
                    </p>
                  </p>
                  <span>{(userGroup && userGroup.name) || "Beta User"}</span>
                </div>
                <div className="foot">
                  <p>
                    {firstName} {lastName}
                  </p>
                </div>
                {/*.foot*/}
              </div>
            </div>
            {getBodyWithClass("hide-xs")}
          </div>
          {/*.rewards-page__points__card*/}

          <div className="rewards-page__points__bar white-bg">
            <p>
              {(rewardsData.hasCompletedOrder &&
                `Earn ${rewardsData.localeGoalRewardPoints} eCoins when you save ${rewardsData.localeGoalPoints}`) ||
                `Earn ${rewardsData.firstOrderPoints} eCoins just after your first order`}
            </p>

            <div className="cursor-pointer" onClick={() => handlePopup(6)}>
              <div className="badge">
                <p>{rewardsData.userLocaleGoalCurrentPoints}</p>
              </div>
              <div className="bg">
                <div
                  className="active"
                  style={{
                    width: `${percentage(
                      100,
                      parseInt(rewardsData.userLocaleGoalCurrentPoints),
                      parseInt(getTotal(rewardsData))
                    )}%`
                  }}
                />
                <div className="d-flex justify-content-evenly">
                  <span />
                  <span />
                  <span />
                </div>
                <div className="d-flex justify-content-between">
                  <p>0</p>
                  <p>{getTotal(rewardsData)}</p>
                </div>
              </div>
            </div>
          </div>
          {/*.rewards-page__points__bar*/}
        </div>
        {/*.rewards-page__points__body*/}
        {getBodyWithClass("visible-xs")}

        {/*.rewards-rewards-page__points__list*/}
        {(isShowingInfo && title && (
          <AppCenteredInfo
            message={body}
            title={title}
            buttonText={buttonText}
            onClickClose={handleCloseInfo}
            onSubmit={handleCloseInfo}
            buttonIcon={buttonIcon}
          />
        )) || <noscript />}
      </div>
    )) || <Loading />
  );
};

export default Points;
